import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { PaymentList, PaymentMethod } from 'src/app/services/payment/methods/methods.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { BonusInfo } from 'src/app/services/payment/bonus/bonus.models';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-payment-method-sheet',
  templateUrl: './payment-method-sheet.component.html',
  styleUrls: ['./payment-method-sheet.component.scss']
})
export class PaymentMethodSheetComponent extends BasePageComponent {


  // @Input() paymentList: PaymentList;
  private _paymentList: PaymentList;
  private _selectedBonus: BonusInfo;

  excludedIds: number[];
  includedIds: number[];

  @Input() selectedMethod: PaymentMethod;

  @Input()
  set paymentList(paymentListInput: PaymentList) {
    if (paymentListInput) {
      this._paymentList = paymentListInput;
    }
  }
  get paymentList(): PaymentList {
    return this._paymentList;
  }

  @Input()
  set selectedBonus(bonus: BonusInfo) {
    if (bonus) {
      this._selectedBonus = bonus;

      this.excludedIds = bonus.excludedOperators;
      this.includedIds = bonus.includedOperators;

    }
  }
  get selectedBonus(): BonusInfo {
    return this._selectedBonus;
  }

  @Output() paymentMethod = new EventEmitter<PaymentMethod>();
  selectDepositName = $localize`:@@deposit-select-method:select deposit method`


  constructor(
    // private _bottomSheetRef: MatDialogRef<PaymentMethodSheetComponent>,
    public detectDeviceService: DetectDeviceService,
    protected licenceService: LicenceService,
    // @Inject(MAT_DIALOG_DATA) public paymentData: { paymentList: PaymentList, excludedIds: number[] },
  ) { super() }

  openLink(event: MouseEvent): void {
    // this._bottomSheetRef.close();
    event.preventDefault();
  }

  ngOnInit(): void {
    // this.excludedIds = this.paymentData.excludedIds || [];
    this.isDesktop = this.detectDeviceService.isDesktop();
  }

  selectPayment(payment: PaymentMethod) {
    // if (!this.excludedIds.includes(payment.id))
    // this._bottomSheetRef.close(payment);
    this.paymentMethod.emit(payment);
  }

}
